import {
  OBTER_MENU_ATENDIMENTO_VIRTUAL_SUCCESS,
  OBTER_MENU_ATENDIMENTO_VIRTUAL_REQUEST,
  OBTER_MENU_ATENDIMENTO_VIRTUAL_ERROR,
} from './constants';

const initialState = {
  data: [],
  loading: true,
  error: '',
};

// eslint-disable-next-line default-param-last
export default function menuAtendimentoVirtual(state = initialState, action) {
  switch (action.type) {
    case OBTER_MENU_ATENDIMENTO_VIRTUAL_SUCCESS: {
      return {
        data: action.payload.itensMenuAtendimentoVirtual,
        loading: false,
        error: '',
      };
    }
    case OBTER_MENU_ATENDIMENTO_VIRTUAL_ERROR: {
      return {
        data: [],
        loading: false,
        error: 'Ocorreu um erro ao carregar o menu do atendimento virtual',
      };
    }
    case OBTER_MENU_ATENDIMENTO_VIRTUAL_REQUEST: {
      return initialState;
    }

    default:
      return state;
  }
}
